module.exports = ['$translateProvider', function ($translateProvider) {
    $translateProvider.translations('it', require('./languages/it'));
    $translateProvider.translations('en', require('./languages/en'));
}];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/module-translations.js
// module id = 292
// module chunks = 0